import { useParams } from 'react-router-dom';
import useVinculacionForm from './services/useVinculacionForm';
import ModalConfirm      from './components/form/ModalConfirm';
import ModalLoading from './components/form/ModalLoading';
import ModalSuccess from './components/form/ModalSuccess';
import VinculacionHeader from './components/VinculacionHeader';
import VinculacionForm from './components/VinculacionForm';
import VinculacionFooter from './components/VinculacionFooter';

import '../../css/Vinculacion.css';


export default function Vinculacion() {
    const { tenant } = useParams();
    const {
        step,
        formData,
        errors,
        showMore,
        modal,
        title,
        icon,
        logoUrls,
        logoFallback,
        companyName,
        options,
        onChange,
        onContinue,
        onBack,
        onToggleShowMore,
        handleModalResponse,
        onClose,
        loadingForm,
        error,
        isSubmitting
    } = useVinculacionForm(tenant);
    // Mientras se carga la empresa, mostramos un mensaje de “cargando”
    if (loadingForm) {
        return (
            <>
                <div className="vinculacion-page">
                    <div className="container text-center" style={{ padding: '4rem 1rem' }}>
                        <div className="spinner" style={{
                            width: '50px',
                            height: '50px',
                            border: '6px solid #e5e7eb',
                            borderTop: '6px solid #3b82f6',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            margin: '0 auto 2rem'
                        }}></div>
                        <p style={{ fontSize: '1.125rem', color: '#374151' }}>Cargando información…</p>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                </div>
                <VinculacionFooter />
            </>
        );
    }
    // Si hubo un error al traer la empresa, lo mostramos
    if (error) {
        return (
            <>
                <div className="vinculacion-page">
                    <div className="container text-center" style={{ padding: '4rem 1rem' }}>
                        <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#dc2626' }}>
                            No pudimos cargar la empresa
                        </h1>
                        <p style={{ fontSize: '1.125rem', color: '#6b7280' }}>
                            Ha ocurrido un error. Intenta nuevamente más tarde.
                        </p>
                        <a
                            href="/"
                            className="btn btn-primary"
                        >
                            Volver al inicio
                        </a>
                    </div>
                </div>
                <VinculacionFooter />
            </>
        );
    }
    return (
        <div className="vinculacion-page">
            <div className="container">
                <VinculacionHeader
                    logoUrls={logoUrls}
                    logoFallback={logoFallback}
                    companyName={companyName}
                    formIcon={icon}
                    formTitle={title}
                />
                <VinculacionForm
                    step={step}
                    data={formData[step]}
                    formData={formData}
                    showMore={showMore}
                    errors={errors}
                    options={options}
                    onToggleShowMore={onToggleShowMore}
                    onBack={onBack}
                    onContinue={onContinue}
                    onChange={onChange}
                />
            </div>
            <ModalConfirm
                visible={modal.visible && ['samePerson','sameTenedorConductor','confirm','policy'].includes(modal.mode)}
                title={modal.title}
                url={modal.url}
                onConfirm={() => handleModalResponse(true)}
                onCancel={()  => handleModalResponse(false)}
                onClose={onClose}
            />
            <ModalLoading 
                visible={isSubmitting}
                message="Enviando información..."
            />

            <ModalSuccess
                visible={modal.visible && modal.mode === 'success'}
                onClose={() => handleModalResponse(true)}
            />
            <VinculacionFooter />
        </div>
    );
}